(function () {
  'use strict';

  // ── Reviews Carousel (Flickity) ──────────────────────────────────────────
  // Uses the theme's existing Flickity library (vendor-scripts-v11.js).
  // Auto-advances every 3 s. No drag, no prev/next buttons, no hover-pause.
  //
  // NOTE: Flickity MUST be initialized while the drawer is visible, or its
  // viewport height will be 0 (hidden elements have no computed dimensions).
  // We initialize lazily on first drawer open, then resize on every open.

  var flkty = null;

  function initReviewsCarousel() {
    var reviews = document.querySelector('[data-cd-reviews]');
    if (!reviews) return;

    var inner = reviews.querySelector('.cd-reviews-inner');
    if (!inner) return;

    // If already initialized, just remeasure and restart autoPlay.
    if (flkty) {
      flkty.resize();
      flkty.playPlayer();
      return;
    }

    var slides = inner.querySelectorAll('[data-cd-slide]');
    if (slides.length <= 1) return;

    if (typeof Flickity === 'undefined') return;

    // Remove the CSS-only active class — Flickity manages visibility itself.
    Array.prototype.forEach.call(slides, function (slide) {
      slide.classList.remove('cd-review-slide--active');
    });

    flkty = new Flickity(inner, {
      autoPlay:             3000,
      pauseAutoPlayOnHover: false,
      prevNextButtons:      false,
      pageDots:             true,
      draggable:            true,
      wrapAround:           true,
      adaptiveHeight:       false,
      setGallerySize:       true,
      friction:             0.8,
      selectedAttraction:   0.14
    });

    // Move Flickity's dot list outside .cd-reviews-inner so it sits below
    // the grey slides area rather than being clipped inside it.
    var dots = inner.querySelector('.flickity-page-dots');
    if (dots) reviews.appendChild(dots);
  }

  // Watch #CartDrawer for class changes (theme adds/removes open class).
  // On open, (re)initialize the carousel so Flickity can measure real dimensions.
  function watchDrawerOpen() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;

    new MutationObserver(function () {
      // Drawer is considered open when it has any width/height (not display:none).
      if (drawer.offsetWidth > 0 || drawer.offsetHeight > 0) {
        // Delay slightly so any CSS transitions have painted the first frame.
        setTimeout(initReviewsCarousel, 80);
      }
    }).observe(drawer, { attributes: true, attributeFilter: ['class', 'aria-hidden', 'style'] });
  }

  // ── Progress Bar ──────────────────────────────────────────────────────────
  // Fill % by item count (matches Figma design proportions):
  //   1 item  → 10%  (slight fill to show the bar is active)
  //   2 items → 44%  (past first milestone at 20% of track)
  //   3+ items→ 100% (past second milestone at 70% of track)

  function getProgressPct(itemCount) {
    if (itemCount <= 1) return 10;
    if (itemCount === 2) return 44;
    return 100;
  }

  function updateProgressBar(itemCount) {
    var section = document.querySelector('[data-cd-progress]');
    if (!section) return;

    var pct = getProgressPct(itemCount);
    var fill = section.querySelector('[data-cd-progress-fill]');
    if (fill) fill.style.width = pct + '%';

    var b1 = section.querySelector('.cd-bubble--1');
    var b2 = section.querySelector('.cd-bubble--2');
    if (b1) b1.classList.toggle('cd-bubble--active', itemCount >= 2);
    if (b2) b2.classList.toggle('cd-bubble--active', itemCount >= 3);

    section.dataset.itemCount = itemCount;
  }

  // ── Promo Bar Message ────────────────────────────────────────────────────

  function updatePromoBar(itemCount) {
    var el = document.querySelector('[data-cd-promo]');
    if (!el) return;
    if (itemCount >= 3) {
      el.textContent = "You've unlocked 20% off your entire order!";
    } else if (itemCount === 2) {
      el.textContent = 'Add one more pair to get 20% off the entire order!';
    } else {
      el.textContent = 'You can never have enough shoes. Add more to get a discount';
    }
  }

  // ── Free Shipping Message ─────────────────────────────────────────────────

  function formatMoney(cents) {
    return '$' + (cents / 100).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function updateShippingMsg(subtotalCents) {
    var el = document.querySelector('[data-cd-shipping]');
    if (!el) return;

    var threshold    = parseInt(el.dataset.threshold    || '10000', 10);
    var shippingCents = parseInt(el.dataset.shippingCents || '699',  10);
    var remaining    = threshold - subtotalCents;

    var pricesEl    = el.querySelector('.cd-shipping-prices');
    var congratsEl  = document.querySelector('[data-cd-congrats]');
    var addMoreEl   = document.querySelector('[data-cd-add-more]');
    var totalEl     = document.querySelector('[data-total]');
    var subtotalEl  = document.querySelector('[data-subtotal]');

    if (pricesEl) {
      if (remaining <= 0) {
        // Free shipping — strikethrough original, show $0.00, congrats visible
        pricesEl.innerHTML =
          '<s class="cd-shipping-original">$6.99</s>' +
          '<span class="cd-shipping-free">$0.00</span>';
        if (addMoreEl)  { addMoreEl.style.display = 'none'; }
        if (congratsEl) { congratsEl.style.display = ''; }
        // Total = subtotal only (shipping is free)
        if (totalEl) { totalEl.textContent = formatMoney(subtotalCents); }
      } else {
        // Paid shipping — show flat $6.99, congrats hidden, show remaining amount
        pricesEl.innerHTML = '<span class="cd-shipping-price">$6.99</span>';
        if (congratsEl) { congratsEl.style.display = 'none'; }
        if (addMoreEl) {
          addMoreEl.textContent = 'Add ' + formatMoney(remaining) + ' more to enjoy Free Shipping';
          addMoreEl.style.display = '';
        }
        // Total = subtotal + $6.99 shipping
        if (totalEl) { totalEl.textContent = formatMoney(subtotalCents + shippingCents); }
      }
    }
  }

  // ── Watch data-products for AJAX cart refreshes ───────────────────────────
  // The theme replaces the contents of [data-products] after every cart update.
  // We observe that div to sync the progress bar and shipping message.

  function watchCartProducts() {
    var productsContainer = document.querySelector('[data-products]');
    if (!productsContainer) return;

    var observer = new MutationObserver(function () {
      var cartItems = productsContainer.querySelector('.cart__items');
      if (!cartItems) return;
      var count    = parseInt(cartItems.dataset.count || '0', 10);
      var subtotal = parseInt(cartItems.dataset.cartSubtotal || '0', 10);
      updateProgressBar(count);
      updatePromoBar(count);
      updateShippingMsg(subtotal);
    });

    observer.observe(productsContainer, { childList: true, subtree: true });
  }

  // Also listen for theme cart events as fallback
  function listenForCartEvents() {
    ['cart:updated', 'cart-drawer:refreshed', 'theme:cart:updated'].forEach(function (evt) {
      document.addEventListener(evt, function () {
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            updateProgressBar(cart.item_count);
            updatePromoBar(cart.item_count);
            updateShippingMsg(cart.total_price);
          })
          .catch(function () {});
      });
    });
  }

  // ── Custom Quick-View Popup ────────────────────────────────────────────────
  // Reads server-side-rendered product JSON from <script type="application/json"
  // id="cd-addon-data-{id}"> tags, builds a lightweight size-pill + ATC popup,
  // and adds to cart via AJAX without touching theme.Modals (so the cart drawer
  // stays open underneath).

  function buildQuickViewDOM() {
    if (document.getElementById('cd-quick-view')) return;
    var el = document.createElement('div');
    el.id = 'cd-quick-view';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Quick Add');
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML = [
      '<div class="cd-qv-backdrop"></div>',
      '<div class="cd-qv-panel">',
        '<button class="cd-qv-close" type="button" aria-label="Close">',
          '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"',
          ' fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"',
          ' stroke-linejoin="round" aria-hidden="true">',
          '<line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>',
          '</svg>',
        '</button>',
        '<div class="cd-qv-top">',
          '<div class="cd-qv-img-wrap">',
            '<img id="cd-qv-img" src="" alt="" class="cd-qv-img">',
          '</div>',
          '<div class="cd-qv-meta">',
            '<h3 id="cd-qv-title" class="cd-qv-title"></h3>',
            '<p id="cd-qv-price" class="cd-qv-price"></p>',
            '<div class="cd-qv-size-label">Select Size</div>',
            '<div id="cd-qv-pills" class="cd-qv-pills" role="group" aria-label="Select size"></div>',
          '</div>',
        '</div>',
        '<p id="cd-qv-feedback" class="cd-qv-feedback" role="status"></p>',
        '<button id="cd-qv-atc" class="cd-qv-atc-btn" type="button">Add to Cart</button>',
      '</div>'
    ].join('');
    var drawer = document.getElementById('CartDrawer') || document.body;
    drawer.appendChild(el);
  }

  function initCustomQuickView() {
    buildQuickViewDOM();

    var overlay      = document.getElementById('cd-quick-view');
    var imgEl        = document.getElementById('cd-qv-img');
    var titleEl      = document.getElementById('cd-qv-title');
    var priceEl      = document.getElementById('cd-qv-price');
    var pillsEl      = document.getElementById('cd-qv-pills');
    var feedbackEl   = document.getElementById('cd-qv-feedback');
    var atcBtn       = document.getElementById('cd-qv-atc');
    var closeBtn     = overlay.querySelector('.cd-qv-close');
    var backdrop     = overlay.querySelector('.cd-qv-backdrop');

    var selectedVariantId = null;
    var escHandler = null;

    function formatCents(cents) {
      return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
    }

    function openQV(data) {
      selectedVariantId = null;
      feedbackEl.textContent = '';
      feedbackEl.className = 'cd-qv-feedback';
      atcBtn.textContent = 'Add to Cart';
      atcBtn.disabled = false;

      imgEl.src = data.image || '';
      imgEl.alt = data.title || '';
      titleEl.textContent = data.title || '';
      priceEl.textContent = formatCents(data.price || 0);

      // Build size pills
      pillsEl.innerHTML = '';
      var variants = data.variants || [];
      var hasMultiple = variants.length > 1 ||
        (variants.length === 1 && variants[0].title !== 'Default Title');

      if (hasMultiple) {
        overlay.querySelector('.cd-qv-size-label').style.display = '';
        pillsEl.style.display = '';
        variants.forEach(function (v) {
          var pill = document.createElement('button');
          pill.type = 'button';
          pill.className = 'cd-qv-pill' + (v.available ? '' : ' cd-qv-pill--soldout');
          pill.textContent = v.title;
          pill.dataset.variantId = String(v.id);
          pill.disabled = !v.available;
          pillsEl.appendChild(pill);
        });
        // Pre-select first available
        var firstAvail = variants.find(function (v) { return v.available; });
        if (firstAvail) {
          setActivePill(String(firstAvail.id));
        }
      } else {
        // Single / default variant — no pills needed
        overlay.querySelector('.cd-qv-size-label').style.display = 'none';
        pillsEl.style.display = 'none';
        if (variants.length > 0) {
          selectedVariantId = String(variants[0].id);
        }
      }

      atcBtn.disabled = false;
      overlay.setAttribute('aria-hidden', 'false');
      overlay.classList.add('cd-qv--open');

      escHandler = function (ev) {
        if (ev.key === 'Escape' || ev.keyCode === 27) closeQV();
      };
      document.addEventListener('keyup', escHandler);
    }

    function setActivePill(variantId) {
      selectedVariantId = variantId;
      var pills = pillsEl.querySelectorAll('.cd-qv-pill');
      Array.prototype.forEach.call(pills, function (p) {
        p.classList.toggle('cd-qv-pill--active', p.dataset.variantId === variantId);
      });
    }

    function closeQV() {
      overlay.classList.remove('cd-qv--open');
      overlay.setAttribute('aria-hidden', 'true');
      if (escHandler) {
        document.removeEventListener('keyup', escHandler);
        escHandler = null;
      }
    }

    // Swallow all clicks inside the overlay so they don't bubble up to the
    // theme's document-level drawer-close handler (which closes the cart
    // drawer whenever it detects a click outside the drawer element).
    overlay.addEventListener('click', function (e) {
      e.stopPropagation();
    });

    // Pill click
    pillsEl.addEventListener('click', function (e) {
      var pill = e.target.closest('.cd-qv-pill:not(.cd-qv-pill--soldout)');
      if (!pill) return;
      setActivePill(pill.dataset.variantId);
    });

    // Backdrop click
    backdrop.addEventListener('click', closeQV);
    closeBtn.addEventListener('click', closeQV);

    // ATC click
    atcBtn.addEventListener('click', function () {
      if (!selectedVariantId) {
        feedbackEl.textContent = 'Please select a size.';
        feedbackEl.className = 'cd-qv-feedback cd-qv-feedback--error';
        return;
      }

      atcBtn.disabled = true;
      atcBtn.textContent = 'Adding…';
      feedbackEl.textContent = '';
      feedbackEl.className = 'cd-qv-feedback';

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(selectedVariantId, 10), quantity: 1 })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Error'); });
          return r.json();
        })
        .then(function () {
          closeQV();
          document.dispatchEvent(new CustomEvent('cart:build'));
          fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              updateProgressBar(cart.item_count);
              updatePromoBar(cart.item_count);
              updateShippingMsg(cart.total_price);
            })
            .catch(function () {});
        })
        .catch(function (err) {
          atcBtn.disabled = false;
          atcBtn.textContent = 'Add to Cart';
          feedbackEl.textContent = err.message || 'Could not add item. Please try again.';
          feedbackEl.className = 'cd-qv-feedback cd-qv-feedback--error';
        });
    });

    // Open handler: delegate on document so it works after cart drawer refreshes
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.cd-addon-atc[data-addon-id]');
      if (!btn) return;

      var addonId = btn.dataset.addonId;
      var scriptEl = document.getElementById('cd-addon-data-' + addonId);
      if (!scriptEl) return;

      var data;
      try { data = JSON.parse(scriptEl.textContent); } catch (_) { return; }
      openQV(data);
    });
  }

  // ── Trash icon — AJAX remove item ─────────────────────────────────────────
  // Intercept .cd-cart-item-remove clicks so the item is removed via AJAX
  // (preventing a full-page reload) and the theme's CartForm rebuilds the drawer.

  function listenForItemRemove() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('.cd-cart-item-remove');
      if (!link) return;

      e.preventDefault();

      var href = link.getAttribute('href') || '';
      // Extract the line item key from href: ?id={key}&quantity=0
      var match = href.match(/[?&]id=([^&]+)/);
      if (!match) return;

      var lineKey = decodeURIComponent(match[1]);

      link.style.opacity = '0.3';
      link.style.pointerEvents = 'none';

      fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: 0 })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          // Let theme rebuild the cart drawer via its own buildCart flow
          document.dispatchEvent(new CustomEvent('cart:build'));
          updateProgressBar(cart.item_count);
          updatePromoBar(cart.item_count);
          updateShippingMsg(cart.total_price);
          var subtotalEl = document.querySelector('[data-subtotal]');
          if (subtotalEl && window.theme && window.theme.Currency) {
            subtotalEl.innerHTML = window.theme.Currency.formatMoney(cart.original_total_price, window.theme.settings.moneyFormat);
          }
        })
        .catch(function () {
          link.style.opacity = '';
          link.style.pointerEvents = '';
        });
    });
  }

  // ── Init ─────────────────────────────────────────────────────────────────

  function init() {
    watchDrawerOpen();
    watchCartProducts();
    listenForCartEvents();
    initCustomQuickView();
    listenForItemRemove();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
